/* eslint-disable react/no-array-index-key */
import React from 'react';
// import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import { Grid, Box } from '@mui/material';

const SectionSkeleton = () => (
    <Grid container justify="center">
      <Grid item lg={10}>
        <Box width="100%" marginTop="3rem">
          <Skeleton animation="wave" variant="rect" height={35} width="40%" />
        </Box>
      </Grid>
      {Array.from(new Array(5)).map((e, i) => (
        <Grid item lg={10} key={i}>
          <Box width="100%" marginTop="3rem" marginBottom="2rem">
            <Skeleton animation="wave" variant="rect" height={25} width="100%" />
          </Box>
        </Grid>
      ))}
    </Grid>
  );

SectionSkeleton.propTypes = {};

export default SectionSkeleton;
